import { render, staticRenderFns } from "./hualu.vue?vue&type=template&id=49ec540d&scoped=true"
import script from "./hualu.vue?vue&type=script&lang=js"
export * from "./hualu.vue?vue&type=script&lang=js"
import style0 from "./hualu.vue?vue&type=style&index=0&id=49ec540d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ec540d",
  null
  
)

export default component.exports